export default "__VITE_ASSET__BURb4Sr9__"